import React, { useEffect } from 'react';
import useSelector from 'components/Booking-new/hooks';
import { pushGTMLocationsDisplayedEvent } from 'utils/gtm';
import pushGTMWithDelay from 'utils/pushGTMWithDelay';
import stepTypes from 'components/Booking-new/modules/Steps/types';
import { getServiceCode, getServiceData } from 'components/Booking-new/utils/steps/service';

const LocationContainer = (Component, { data, navigation, userData }) => {
  const { results } = useSelector(state => ({
    errorData: state?.config?.errorPage,
    selectedCity: state?.selectedCity,
    serviceData:
      getServiceData(state?.services.nodes, state?.userData[stepTypes.reschedule]?.service.service) ||
      state?.config?.service,
    serviceCode: getServiceCode(state?.userData[stepTypes.reschedule]?.service.service, state?.config?.service?.code),
    changeServiceLink: state?.config?.changeServiceLink,
    showNewsBanner: state?.config?.showNewsBanner,
    funnelType: state?.config?.funnelType,
    rescheduleData: state?.userData[stepTypes.reschedule]?.appointment?.appointmentid,
  }));

  useEffect(() => {
    window.scrollTo(0, 0);
    pushGTMWithDelay(33, pushGTMLocationsDisplayedEvent, {
      service: results?.serviceCode,
      funnelType: results?.funnelType,
    });
  }, []);

  const stepLocationComponentData = {
    stepLocationData: { ...data, locations: results?.selectedCity?.locations || data.locations },
    selectedCity: results?.selectedCity,
    service: results?.serviceData,
    changeServiceLink: results?.changeServiceLink,
    showNewsBanner: results?.showNewsBanner,
    userData,
    funnelType: results?.funnelType,
    navigation,
    rescheduleData: results?.rescheduleData,
    serviceCode: results?.serviceCode,
  };

  return <Component {...stepLocationComponentData} />;
};

export default LocationContainer;
